/**
 * Utility functions for data table filters
 */ /**
 * Serializes number range values (min, max) into a URL-safe string format
 *
 * Format: "min-max" where min and max are optional
 * Examples:
 * - Both values: "5-10" (min=5, max=10)
 * - Min only: "5-" (min=5, no max)
 * - Max only: "-10" (no min, max=10)
 * - Empty: "" (no values)
 *
 * @param min - Minimum value (as string)
 * @param max - Maximum value (as string)
 * @returns Serialized string
 */ export function serializeNumberRange(min, max) {
    const hasMin = min.trim() !== "";
    const hasMax = max.trim() !== "";
    if (!hasMin && !hasMax) {
        return "";
    }
    return `${min}-${max}`;
}
/**
 * Deserializes a URL string into number range values (min, max)
 *
 * @param value - Serialized string from URL
 * @returns Object with min and max as strings
 */ export function deserializeNumberRange(value) {
    if (!value || value.trim() === "") {
        return {
            min: "",
            max: ""
        };
    }
    // Split by the delimiter '-'
    const parts = value.split("-");
    if (parts.length === 2) {
        return {
            min: parts[0] || "",
            max: parts[1] || ""
        };
    }
    // Fallback: treat as min value only if no delimiter found
    return {
        min: value,
        max: ""
    };
}

//# sourceMappingURL=utils.js.map